// extracted by css-extract-rspack-plugin
export default {"textModal":"text-modal--rVMBi1Vuc2ISXMTv"};